module.exports = __webpack_public_path__ + "static/timetravel_img7jpg-880940c65591aeb904cbb6c3e5a3cd7f.png";